<template>
  <div class="consult-container">
    <div class="content">
      <top-question @handle-choose="handleChoose"></top-question>
      <div class="messge-content" ref="message">
        <div v-for="(item, index) in messageList" :key="index" class="item-list">
          <div v-if="item.type === 1" class="customer">
            <van-image round width="50px" height="50px" :src="defaultHeadImg" />
            <div class="customer-right">
              <div class="roleName">
                水务咨询机器人
              </div>
              <div class="message" v-if="item.messType === 1">
                <div class="title" v-if="item.title">{{ item.title }}</div>
                <div v-html="$xss(item.message)" class="message-info"></div>
              </div>
              <div class="handle" v-if="item.messType === 1 && item.title">
                <div style="margin-right:3px" @click="doResolve(item, index)" v-if="!item.resolve && !item.unResolve">
                  <van-icon name="good-job" />解决
                </div>
                <div style="margin-right:3px" v-else>
                  <van-icon :class="{ resolve: item.resolve }" name="good-job" />解决
                </div>
                <div style="margin-left:3px" @click="doUnResolve(item, index)" v-if="!item.unResolve && !item.resolve">
                  <van-icon class="down" name="good-job" />未解决
                </div>
                <div style="margin-left:3px" v-else>
                  <van-icon class="down" :class="{ unResolve: item.unResolve }" name="good-job" />未解决
                </div>
              </div>
              <div class="message" v-if="item.messType === 2">
                <ul>
                  <li v-for="(item, idx) in item.message" :key="idx" @click="getResult(item)">{{ item.title }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div v-if="item.type === 2" class="user">
            <van-image round width="40px" height="40px" :src="headimgurl" />
            <div class="message">
              {{ item.message }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <top-labels class="label" @handle-choose="handleChoose"></top-labels>
      <div class="search">
        <van-search
          v-model="searchTxt"
          shape="round"
          background="#fff"
          style="width:100%;"
          @focus="handleFocus"
          readonly
          placeholder="请用一句话简要、准确描述您的问题"
        />
      </div>
    </div>
    <van-popup class="popup-question" v-model="showSearch" :overlay="false" round position="bottom">
      <div class="header">
        <span class="q-title">您是想问?</span>
        <van-icon class="popup-icon" name="cross" size="20" @click="popupClose" />
      </div>
      <question-search v-if="showSearch" @send-done="handleSend"></question-search>
    </van-popup>
  </div>
</template>

<script>
import TopLabels from "./TopLabels.vue";
import TopQuestion from "./TopQuestion.vue";
import QuestionSearch from "./QuestionSearch.vue";
import { loadUserInfo } from "@/utils/cache";
import { getAnswers, doUnResolved, doResolved } from "@/api/business";
export default {
  components: { TopQuestion, TopLabels, QuestionSearch },
  data() {
    return {
      searchTxt: "",
      showSearch: false,
      messageList: [
        {
          type: 1,
          messType: 1,
          message: "很高兴为您服务，有什么可以帮您？"
        }
      ],
      defaultHeadImg: require("@/assets/customer.jpeg"),
      headimgurl: ""
    };
  },
  created() {
    let { headimgurl } = loadUserInfo();
    this.headimgurl = headimgurl;
  },
  methods: {
    handleFocus() {
      this.showSearch = true;
    },
    popupClose() {
      this.showSearch = false;
    },
    handleSend(val) {
      this.showSearch = false;
      this.handleChoose(val);
    },
    handleChoose(val) {
      this.messageList.push({
        type: 2,
        message: val
      });
      this.getAnswers(val);
    },
    async getAnswers(val) {
      let { status, resultData } = await getAnswers({
        word: val
      });
      if (status === "complete") {
        let res = resultData.data;
        if (resultData.type === 1) {
          if (res && res.length > 0) {
            let obj = {
              messType: resultData.type,
              title: res[0].title,
              message: res[0].content,
              resolve: false,
              unResolve: false,
              type: 1,
              knowledgeId: res[0].knowledgeId
            };
            this.messageList.push(obj);
          } else {
            this.messageList.push({
              type: 1,
              messType: 1,
              message: "不好意思,没有理解你的意思。没有帮到您！"
            });
          }
        } else {
          if (res.length > 0) {
            let obj = {
              messType: resultData.type,
              message: res,
              type: 1
            };
            this.messageList.push(obj);
          } else {
            this.messageList.push({
              type: 1,
              messType: 1,
              message: "不好意思,没有理解你的意思。没有帮到您！"
            });
          }
        }

        this.$nextTick(() => {
          this.$refs.message.scrollIntoView({ block: "end", behavior: "smooth" });
        });
      }
    },
    getResult(item) {
      this.getAnswers(item.title);
    },
    async doResolve(item, index) {
      let { status } = await doResolved({
        knowledgeId: item.knowledgeId
      });
      if (status === "complete") {
        this.$set(this.messageList[index], "resolve", true);
      }
    },
    async doUnResolve(item, index) {
      let { status } = await doUnResolved({
        knowledgeId: item.knowledgeId
      });
      if (status === "complete") {
        this.$set(this.messageList[index], "unResolve", true);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.consult-container {
  display: flex;
  flex-direction: column;
  font-family: PingFangSC-Regular;

  .content {
    padding: 10px;
    height: calc(100vh - 120px);
    overflow: auto;

    .item-list {
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0px;
      }
    }

    .messge-content {
      margin-top: 20px;

      .customer {
        display: flex;

        .customer-right {
          margin-left: 10px;
          flex: 1;

          .roleName {
            font-size: 13px;
            color: #797979;
            margin-bottom: 8px;
          }

          .message {
            background: #fff;
            border-top-right-radius: 8px;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            padding: 10px;

            .title {
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 10px;
            }

            &-info {
              font-size: 13px;
              font-weight: 300;
              color: #797979;
              /deep/ p {
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            ul li {
              color: #1989fa;
              font-size: 12px;
              font-weight: 500;
              margin-bottom: 8px;

              &:last-child {
                margin-bottom: 0px;
              }
            }
          }

          .handle {
            display: flex;
            margin-top: 6px;

            div {
              flex: 1;
              background: #fff;
              border-radius: 6px;
              text-align: center;
              padding: 6px 0px;
              color: #797979;
            }
          }
        }

        .down {
          transform: rotate(-180deg);
        }
        .unResolve {
          color: #ff976a;
        }
        .resolve {
          color: #1989fa;
        }
      }

      .user {
        display: flex;
        flex-direction: row-reverse;

        .message {
          margin-left: 10px;
          background: #1989fa;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          padding: 10px 6px;
          color: #fff;
          font-size: 13px;
        }
      }
    }
  }

  .bottom {
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0;
    left: 0;

    .label {
      height: 40px;
      line-height: 40px;
    }

    .search {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #ffffff;
    }
  }

  .popup-question {
    width: 100%;

    .header {
      height: 36px;
      line-height: 36px;
      font-family: PingFangSC-Regular;
      border-bottom: 1px solid #eee;

      .q-title {
        font-size: 14px;
        font-weight: bold;
        margin-left: 10px;
      }
    }

    .popup-icon {
      position: absolute;
      z-index: 3333;
      top: 12px;
      right: 12px;
    }
  }
}
</style>
